import { createFileRoute } from '@tanstack/react-router'

import { CallTimelinePage } from '#/modules/communication/call-timeline'

interface CallTimelineSearch {
  organizationId?: string
}

export const Route = createFileRoute('/_shell/calls/$callId')({
  validateSearch: (search: Record<string, unknown>): CallTimelineSearch => ({
    organizationId: typeof search.organizationId === 'string' ? search.organizationId : undefined,
  }),
  component: function CallTimelineRoute() {
    const { callId } = Route.useParams()
    const { organizationId } = Route.useSearch()
    return <CallTimelinePage callId={callId} organizationId={organizationId ?? null} />
  },
})
